/* Umbra gift guide extras (B10E): the ribbon between tiers draws in once, the first time its seam scrolls into view.
   Loaded deferred, only on the gift guide page and only while the ribbon setting is on (snippets/umbra-gift-extras.liquid).
   The CSS (assets/umbra-gift-extras.css) holds the band at scaleX(0) and the bow at opacity 0 only under html.gx-js and
   until .gx-in lands on the seam's section; without this script, or under prefers-reduced-motion, the ribbon is simply there.
   B11C: the same observer also keeps .gx-live on a seam while it is on screen, so the glint loop of
   gift_extras_ribbon_motion (html.gx-sheen) runs only for a seam the shopper can see and pauses off screen.
   R1104 TAGS: under html.gx-swing (gift_extras_tag_motion) the same observer also marks each tier title with .gx-in the
   first time it scrolls into view, so its tied tag swings in once; without the class nothing here changes. */
(function () {
  'use strict';
  var seams = Array.prototype.slice.call(document.querySelectorAll('.umbra-set-section + .umbra-set-section .umbra-set'));
  if (document.documentElement.classList.contains('gx-swing')) {
    seams = seams.concat(Array.prototype.slice.call(document.querySelectorAll('.umbra-gift-set .umbra-set__head .umbra-ed__heading')));
  }
  if (!seams.length) return;
  var show = function (el) { el.classList.add('gx-in'); el.classList.add('gx-live'); };
  if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(seams, show); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      e.target.classList.toggle('gx-live', e.isIntersecting);
      if (e.isIntersecting) e.target.classList.add('gx-in');
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
  Array.prototype.forEach.call(seams, function (el) { io.observe(el); });
})();
